import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sort'
})
export class SortPipe<T> implements PipeTransform {
    transform (array: T[], property?: keyof T, order: 'asc' | 'desc' = 'asc'): T[] {
        if (!array || array.length === 0) return array;

        return array.slice().sort((a, b) => {
            if (!property) {
                if (typeof a === 'string' && typeof b === 'string') {
                    return order === 'asc' ? a.localeCompare(b) : b.localeCompare(a);
                }
                if (typeof a === 'number' && typeof b === 'number') {
                    return order === 'asc' ? a - b : b - a;
                }
                return 0;
            }

            const valueA = a[property];
            const valueB = b[property];

            if (valueA == null || valueB == null) return 0;

            if (typeof valueA === 'string' && typeof valueB === 'string') {
                return order === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
            }

            if (typeof valueA === 'number' && typeof valueB === 'number') {
                return order === 'asc' ? valueA - valueB : valueB - valueA;
            }

            return 0;
        });
    }
}
